<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/quoting/shared/quoting-basket-line-items/quoting-basket-line-items.component.ts
-->
<ng-template #anchor></ng-template>
